import { BaseFetch } from "../main-model"
export default class SubAnalysisModel extends BaseFetch {
  getSubAnalysisBy = (data) =>
    this.authFetch({
      url: "sub-analysis/getSubAnalysisBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getSubAnalysisById = (data) =>
    this.authFetch({
      url: "sub-analysis/getSubAnalysisById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateSubAnalysisById = (data) =>
    this.authFetch({
      url: "sub-analysis/updateSubAnalysisById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertSubAnalysis = (data) =>
    this.authFetch({
      url: "sub-analysis/insertSubAnalysis",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteSubAnalysisById = (data) =>
    this.authFetch({
      url: "sub-analysis/deleteSubAnalysisById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
